/* eslint complexity: ["error", 40] */

import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Container, Fade, Carousel, Row, Col, Form, Tab, Tabs, Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import { withRouter, Redirect } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Formik } from 'formik';
import PartnerCameraCalibration from './partner-camera-calibration';
import CommonMetaTag from './common-meta-tag';
import Configuration from '../config';
import terrainIcon from '../images/terreno_campo.svg';
import swimmingPoolIcon from '../images/terreno_piscina.svg';
import pointerIcon from '../images/pointer_icon.svg';
import envelopeIcon from '../images/envelope_icon.svg';
import phoneIcon from '../images/phone_icon.svg';
import indoorIcon from '../images/indoor_icon.svg';
import outdoorIcon from '../images/outdoor_icon.svg';
import editIcon from '../images/edit_icon.svg';
import { SPORTS, xmlType } from '../constants';
import { updatePartnerByAdmin, updatePartnerDedicatedPageByAdmin, updatePartnerFieldByAdmin, updatePartnerServiceByAdmin, newXml, showXmlModal, hideXmlModal, saveXml, showCameraModal, hideCameraModal, newCamera, editCamera, createCamera, deleteCamera, modifyCamera, updatePartnerVideoCostByAdmin, newXmlPartnerVideo, showXmlPartnerVideoModal, hideXmlPartnerVideoModal, savePartnerVideoXml, changePartnerPermissions, setAdminShowPartnerTab } from '../actions/admin';
import AdminPartnerRtvChannels from './admin-partner-rtv_channels';
import FormFileInput from 'react-bootstrap/esm/FormFileInput';
import Dialog from 'react-bootstrap-dialog';
import AdminShop from './admin-shop';
import AdminCreateField from './admin-create-field';
import {isFieldCopy, fieldCopyLabel} from '../util/field-copy';
import {getPartnerFields} from '../actions/admin';
import AdminP2pField from './admin-p2p-field';


export const AdminShowPartner = ({
  partner,
  token,
  fields,
  services,
  rtvChannels,
  updatePartner,
  updatePartnerDedicatedPage,
  updatePartnerField,
  updatePartnerService,
  selectedXml,
  newXmlModal,
  newXmlPartnerVideoModal,
  showXmlModal,
  hideXmlModal,
  hideXmlPartnerVideoModal,
  isXmlModalVisible,
  isXmlPartnerVideoModalVisible,
  hideCameraModal,
  cameraModal,
  selectedCamera,
  isCameraModalVisible,
  createXml,
  createPartnerVideoXml,
  removeFile,
  createOrEditCamera,
  deleteCamera,
  updatePartnerVideoCost,
  changePartnerPermissions,
  adminShowPartnerTab,
  setAdminShowPartnerTab,
  refreshFields
}) => {
  const { t } = useTranslation();
  const [selectedFile, setSelectedFile] = useState();
  const [calibrationField, setCalibrationField] = useState(null);
  const [createFieldOpen, setCreateFieldOpen] = useState(false);
  const xmlCopy = isFieldCopy(fields.find(field => selectedXml && field.id === selectedXml.fieldId));

  const fileChangeHandler = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  if (token === null) {
    return (
      <Redirect to="/login" />
    );
  }

  if (partner === null) {
    return (
      <Fragment>
        <div className="page-header header-filter clear-filter dashboard_hero_rp" data-parallax="true">
          <div className="dashboard_hero_overlay_rp" />
        </div>
        <div className="main main_raised_rp">
          <div className="section">
            <div className="container">
              <div className="row">
                <div className="col-12 mb-sm-2 mb-md-4">
                  <div className="detail_head_rp rounded">
                    <h4 className="section_title_neg_rp">{t('NO_PARTNER_SELECTED')}</h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }

  let dialog = null;

  const deleteCameraDialog = (cameraId, partnerId) => {
    dialog.show({
      title: t('DELETE_CAMERA'),
      body: t('DELETE_CAMERA_INFO'),
      actions: [
        Dialog.Action(
          t('DELETE'),
          () => deleteCamera(cameraId, partnerId),
          'btn btn-secondary'
        ),
        Dialog.Action(
          t('NO'),
          null,
          'btn btn_red_outline_rp'
        )
      ],
      bsSize: 'small',
      onHide: dialog => {
        dialog.hide();
      }
    });
  };

  return (
    <Fragment>
      {createFieldOpen && <AdminCreateField partner={partner} token={token} onHide={() => setCreateFieldOpen(false)} onCreated={() => refreshFields(partner.uid)}/>}
      {calibrationField !== null && <PartnerCameraCalibration fieldId={calibrationField} token={token} onHide={() => setCalibrationField(null)}/>}
      <CommonMetaTag />
      <Fade in appear className="bg_white" style={{ transition: 'opacity 0.30s linear' }}>
        <Container fluid className="presentation-container">
          <div className="page-header header-filter clear-filter dashboard_hero_rp" data-parallax="true">
            <div className="dashboard_hero_overlay_rp" />
          </div>
          <div className="main main_raised_rp">
            <div className="section">
              <div className="container">
                <div className="row">
                  <div className="col-12 mb-sm-2 mb-md-4">
                    <div className="detail_head_rp rounded">
                      <h4 className="section_title_neg_rp">{partner.businessName}</h4>
                      <p>{partner.isSpecialist ? "Sport Specialist" : t('SPORTS_CENTER')}</p>
                      <hr className="hr_blue" />
                      <ul className="list-unstyled list-inline row">
                        <li className="list-inline-item col-lg-4 mb-1"><img src={pointerIcon} alt={t('ICON_POINTER')} />{partner.city}, {partner.address}</li>
                        <li className="list-inline-item col-lg-4 mb-1"><img src={envelopeIcon} alt={t('ICON_EMAIL')} /><a href={`mailto:${partner.user.email}`}>{partner.user.email}</a></li>
                        <li className="list-inline-item col-lg-4 mb-1"><img src={phoneIcon} alt={t('ICON_PHONE')} /><a href={`tel:${partner.phoneNumber}`}>{partner.phoneNumber}</a></li>
                      </ul>
                      <hr className="hr_blue" />
                      <h5 className="section_title_neg_rp">{t('TAX_DATA')}</h5>
                      <ul className="list-unstyled list-inline row">
                        <li className="list-inline-item col-lg-4 mb-1">{t('REGISTERED_OFFICE')}:{" " + partner.registeredOffice}</li>
                        <li className="list-inline-item col-lg-4 mb-1">{t('VAT_NUMBER')}:{" " + partner.iva}</li>
                        <li className="list-inline-item col-lg-4 mb-1">{t('SDI_PEC')}:{" " + partner.sdiPec}</li>
                      </ul>
                      <hr className="hr_blue" />
                      <div className="row" style={{ minHeight: 200 }}>
                        {
                          partner.openingHour && partner.openingHour.sportsCenter ?
                            <div className="col-lg-6 mt-sm-2 mb-sm-2 mb-lg-4">
                              <h5 className="section_title_neg_rp">{t('SPORTS_CENTER_HOURS')}</h5>
                              <ul className="list-unstyled">
                                {partner.openingHour.sportsCenter.split('\n').map(t => <li>{t}</li>)}
                              </ul>
                            </div> :
                            null
                        }
                        {
                          partner.openingHour && partner.openingHour.secretary ?
                            <div className="col-lg-6 mt-sm-2 mb-sm-2 mb-lg-4">
                              <h5 className="section_title_neg_rp">{t('SECRETARIAT_HOURS')}</h5>
                              <ul className="list-unstyled">
                                {partner.openingHour.secretary.split('\n').map(t => <li>{t}</li>)}
                              </ul>
                            </div> :
                            null
                        }
                      </div>
                      <hr className="hr_blue" />
                      <Formik
                        enableReinitialize
                        initialValues={{
                          videoStore: partner.videoStore,
                          affiliationsOnlinePayment: partner.affiliationOnlinePayment || partner.affiliationsOnlinePayment || false,
                          shopActive: partner.shopActive || false,
                          openMatchesEnabled: partner.openMatchesEnabled || false
                        }}
                        onSubmit={v => changePartnerPermissions(v, partner.uid)}
                      >
                        {({
                          handleSubmit,
                          handleChange,
                          values
                        }) => {
                          return (
                            <Form onSubmit={handleSubmit}>
                              <Form.Group>
                                <Form.Row>
                                  <Form.Check name="videoStore" type="checkbox" label={t('PUBLISH_VIDEO_STORE')} checked={values.videoStore} onChange={handleChange} style={{ marginRight: 20 }} />
                                  <Form.Check name="affiliationsOnlinePayment" type="checkbox" label={t('AFFILIATIONS_ONLINE_PAYMENT')} checked={values.affiliationsOnlinePayment} onChange={handleChange} style={{ marginRight: 20 }} />
                                  <Form.Check name="shopActive" type="checkbox" label="Abilita shop circolo" checked={values.shopActive} onChange={handleChange} style={{ marginRight: 20 }} />
                                  <Form.Check name="openMatchesEnabled" type="checkbox" label="Abilita partite aperte" checked={values.openMatchesEnabled} onChange={handleChange} />
                                </Form.Row>
                              </Form.Group>
                              <Button type="submit">{t('SAVE')}</Button>
                            </Form>
                          )
                        }}
                      </Formik>
                      <hr className="hr_blue" />
                      <h5 className="section_title_neg_rp">{t('CLUB_DEDICATED_PAGE')}</h5>
                      <Formik
                        enableReinitialize
                        initialValues={{
                          dedicatedPageEnabled: partner.dedicatedPageEnabled || false,
                          publicSlug: partner.publicSlug || ''
                        }}
                        onSubmit={values => updatePartnerDedicatedPage(partner.uid, values)}
                      >
                        {({handleSubmit, handleChange, values}) => (
                          <Form onSubmit={handleSubmit}>
                            <Form.Group>
                              <Form.Check
                                name="dedicatedPageEnabled"
                                type="checkbox"
                                label="Abilita pagina dedicata"
                                checked={values.dedicatedPageEnabled}
                                onChange={handleChange}
                              />
                            </Form.Group>
                            <Form.Group>
                              <Form.Label>{t('SUBDOMAIN')}</Form.Label>
                              <Form.Control
                                required={values.dedicatedPageEnabled}
                                name="publicSlug"
                                value={values.publicSlug}
                                onChange={handleChange}
                                pattern="[a-z0-9]+(?:-[a-z0-9]+)*"
                                placeholder="nome-circolo"
                              />
                              <Form.Text className="text-muted">
                                Anteprima: {window.location.origin}/club/{values.publicSlug || 'nome-circolo'}
                              </Form.Text>
                            </Form.Group>
                            <Button type="submit">{t('SAVE')}</Button>{' '}
                            {partner.dedicatedPageEnabled && (
                              <Button
                                type="button"
                                variant="outline-primary"
                                onClick={() => window.open(`/club/${partner.publicSlug}`, '_blank', 'noopener,noreferrer')}
                              >
                                {t('OPEN_DEDICATED_PAGE')}
                              </Button>
                            )}
                          </Form>
                        )}
                      </Formik>
                    </div>
                  </div>
                </div>
                <Tabs activeKey={adminShowPartnerTab} onSelect={key => setAdminShowPartnerTab(key)} defaultActiveKey="campi" className="admin-show-partner-tabs" style={{ marginTop: 50, marginBottom: 50 }}>
                  <Tab eventKey="campi" title={t('FIELDS')} tabClassName="admin-show-partner-tab">
                    <Button className="mb-3" onClick={() => setCreateFieldOpen(true)}>Crea campo</Button>
                    <div className="row">
                      {
                        fields.map(f =>
                        (
                          <div key={f.id} className="col-md-12 col-lg-4 mb-sm-4 card-group">
                            <div className="card sportcenter_card_bg_rp">
                              <div className="card_image_rp">
                                {
                                  f.imagesNames.length === 0 ?
                                    <div className="videoWrapper card_image_sportcenter_rp" /> :
                                    <Carousel style={{ marginBottom: 10 }} interval={null}>
                                      {
                                        f.imagesNames.map(i =>
                                        (
                                          <Carousel.Item key={i}>
                                            <img
                                              className="d-block w-100"
                                              src={`${Configuration.apiEndPoint}/partners/fields/${f.id}/images?load=${i}`}
                                              alt={t('FIRST_SLIDE')}
                                              style={{ width: '100%' }}
                                            />
                                          </Carousel.Item>
                                        )
                                        )
                                      }
                                    </Carousel>
                                }
                              </div>
                              <p style={{ textAlign: 'right', marginRight: 5 }}>id: {f.id}</p>
                              <div className="card-body d-flex flex-column card_border_bottom_white mb-3">
                                <div className="d-flex">
                                  <div className="sportcenter_rp_title_icon">
                                    <img src={SPORTS[f.sport] ? SPORTS[f.sport].icon : null} alt={t('ICON_SPORT')} />
                                  </div>
                                  <div>
                                    <h5 className="card-title">{f.name}</h5>
                                    {isFieldCopy(f) && <p className="text-info">{fieldCopyLabel(f)}</p>}
                                    <p>{f.sport}</p>
                                  </div>
                                </div>
                                <p>{f.description}</p>
                                <ul className="card_facilities_list_icons">
                                  {
                                    f.covered ?
                                      <li className="card_facilities_list_icons_item"><img src={`${outdoorIcon}`} alt={t('ICON_OUTDOOR')} /> {t('OPEN_FIELD')}</li> :
                                      <li className="card_facilities_list_icons_item"><img src={`${indoorIcon}`} alt={t('ICON_OUTDOOR')} /> {t('COVERED_FIELD')}</li>
                                  }
                                  {
                                    f.terrain === 'Piscina' ?
                                      <li className="card_facilities_list_icons_item pd-lg-4"><img src={`${swimmingPoolIcon}`} alt={t('ICON_TERRAIN')} />{f.terrain}</li> :
                                      <li className="card_facilities_list_icons_item pd-lg-4"><img src={`${terrainIcon}`} alt={t('ICON_TERRAIN')} />{f.terrain}</li>
                                  }
                                </ul>
                              </div>
                              <div className="card-body d-flex flex-column card_border_bottom_white mb-3" style={{ borderBottom: "none" }}>
                                {!isFieldCopy(f) && <AdminP2pField key={f.id} fieldId={f.id} token={token}/>}
                                <Formik
                                  enableReinitialize
                                  initialValues={{ id: f.id, configurationReadOnly: isFieldCopy(f), partnerCalibrationEnabled: !!f.partnerCalibrationEnabled, rtv: f.rtv, recording: f.recording, payment: f.payment, cameras: f.cameras, videoHourPrice: f.videoHourPrice && f.videoHourPrice ? f.videoHourPrice / 100 : 0.01 }}
                                  onSubmit={updatePartnerField}
                                >
                                  {({
                                    handleSubmit,
                                    handleChange,
                                    values
                                  }) => {
                                    return (
                                      <Form onSubmit={handleSubmit}>
                                        <Form.Group>
                                          <Form.Check name="payment" type="checkbox" label={t('FIELD_PAYMENT')} checked={values.payment} onChange={handleChange} />
                                        </Form.Group>
                                        <Form.Group controlId={`video-hour-price-${f.id}`}>
                                          <Form.Label>{t('VIDEO_HOUR_PRICE')} (€/h)</Form.Label>
                                          <Form.Control name="videoHourPrice" placeholder={t('VIDEO_HOUR_PRICE')} type="number" min={0.01} max={100} step={0.01} value={values.videoHourPrice || ''} onChange={handleChange} />
                                        </Form.Group>
                                        <Form.Group>
                                          <Form.Check disabled={isFieldCopy(f)} id={`partner-calibration-${f.id}`} name="partnerCalibrationEnabled" type="checkbox" label={t('PARTNER_CALIBRATION_ENABLED')} checked={values.partnerCalibrationEnabled} onChange={handleChange}/>
                                        </Form.Group>
                                        <Form.Group>
                                          <Button disabled={isFieldCopy(f)} type="button" variant="outline-primary" onClick={() => setCalibrationField(f.id)}>{t('CAMERA_CALIBRATION')}</Button>
                                        </Form.Group>
                                        <Form.Label>{t('CAMERA_MANAGEMENT')}</Form.Label>
                                        {
                                          values.cameras.sort((a, b) => a.position - b.position).map((camera, index) =>
                                            <li key={camera.id} className="list-group-item d-flex justify-content-between align-items-center" style={{ paddingRight: 0, paddingTop: 2, paddingBottom: 2 }}>
                                              <div className="d-flex align-items-center">
                                                <div className="ms-3">
                                                  <p className="fw-bold mb-1">{index + 1}. {camera.name} (id: {camera.id})</p>
                                                </div>
                                              </div>
                                              <span className="card_video_archive_list_icons_item"><button disabled={isFieldCopy(f)} type="button" style={{background: "transparent", border: 0, padding: 0}} onClick={() => cameraModal(camera)}><img src={editIcon} alt={t('ICON_MODIFY')} /></button></span>
                                            </li>
                                          )
                                        }
                                        <br />
                                        {values.cameras.length > 0 ?
                                          <div>
                                            <Form.Group>
                                              <Form.Check name="rtv" type="checkbox" label={t('REPLAYER_TV')} checked={values.rtv} onChange={handleChange} />
                                            </Form.Group>
                                            <Form.Group>
                                              <Form.Check name="recording" type="checkbox" label={t('VIDEO_RECORDING')} checked={values.recording} onChange={handleChange} />
                                            </Form.Group>
                                          </div>
                                          : null}
                                        <Form.Group>
                                          <Button type="submit">{t('SAVE')}</Button>
                                          <Button disabled={isFieldCopy(f)} variant="secondary" onClick={() => cameraModal(null, values.id)} style={{ marginLeft: 10 }}>{t('ADD_CAMERA')}</Button>
                                        </Form.Group>
                                        <Form.Group>
                                          <Button variant="primary" onClick={() => {setSelectedFile(undefined); newXmlModal(values.id);}}>{t('XML_UPLOAD')}</Button>
                                        </Form.Group>
                                      </Form>
                                    );
                                  }}
                                </Formik>
                              </div>
                            </div>
                          </div>
                        )
                        )
                      }
                    </div>
                  </Tab>
                  <Tab eventKey="servizi" title={t('SERVICES')} tabClassName="admin-show-partner-tab">
                    <div className="row">
                      {
                        services.map(s =>
                        (
                          <div key={s.id} className="col-md-12 col-lg-4 mb-sm-4 card-group">
                            <div className="card sportcenter_card_bg_rp">
                              <div className="card_image_rp">
                                {
                                  s.imagesNames.length === 0 ?
                                    <div className="videoWrapper card_image_sportcenter_rp" /> :
                                    <Carousel style={{ marginBottom: 10 }} interval={null}>
                                      {
                                        s.imagesNames.map(i =>
                                        (
                                          <Carousel.Item key={i}>
                                            <img
                                              className="d-block w-100"
                                              src={`${Configuration.apiEndPoint}/partners/services/${s.id}/images?load=${i}`}
                                              alt={t('FIRST_SLIDE')}
                                              style={{ width: '100%' }}
                                            />
                                          </Carousel.Item>
                                        )
                                        )
                                      }
                                    </Carousel>
                                }
                              </div>
                              <p style={{ textAlign: 'right', marginRight: 5 }}>id: {s.id}</p>
                              <div className="card-body d-flex flex-column card_border_bottom_white mb-3">
                                <h5 className="card-title">{s.name}</h5>
                                <p>{s.description}</p>
                              </div>
                              <div className="card-body d-flex flex-column card_border_bottom_white mb-3">
                                <Formik
                                  initialValues={{ id: s.id, rtv: s.rtv, recording: s.recording, payment: s.payment, videoHourPrice: s.videoHourPrice && s.videoHourPrice ? s.videoHourPrice / 100 : 0.01 }}
                                  onSubmit={updatePartnerService}
                                >
                                  {({
                                    handleSubmit,
                                    handleChange,
                                    values
                                  }) => {
                                    return (
                                      <Form onSubmit={handleSubmit}>
                                        {/*
                                          <Form.Group>
                                            <Form.Check name="rtv" type="checkbox" label={t('REPLAYER_TV')} checked={values.rtv} onChange={handleChange}/>
                                          </Form.Group>
                                          <Form.Group>
                                            <Form.Check name="recording" type="checkbox" label={t('VIDEO_RECORDING')} checked={values.recording} onChange={handleChange}/>
                                          </Form.Group>
                                          */}
                                        <Form.Group>
                                          <Form.Check name="payment" type="checkbox" label={t('SERVICE_PAYMENT')} checked={values.payment} onChange={handleChange} />
                                        </Form.Group>
                                        {/*
                                          <Form.Group>
                                            <Form.Label>{t('VIDEO_HOUR_PRICE')}</Form.Label>
                                            <Form.Control name="videoHourPrice" placeholder={t('VIDEO_HOUR_PRICE')} type="number" min={0.01} max={100} step={0.01} value={values.videoHourPrice || ''} onChange={handleChange}/>
                                          </Form.Group>
                                          */}
                                        <Button type="submit">{t('SAVE')}</Button>
                                      </Form>
                                    );
                                  }}
                                </Formik>
                              </div>
                            </div>
                          </div>
                        )
                        )
                      }
                    </div>
                  </Tab>
                  <Tab eventKey="rtv_channels" title={t('RTV_CHANNELS')} tabClassName="admin-show-partner-tab">
                    <div className="detail_head_rp rounded" style={{ marginBottom: 20 }}>
                      <Formik
                        initialValues={
                          {
                            uid: partner.uid,
                            rtvKeepVideos: partner.rtvKeepVideos
                          }
                        }
                        onSubmit={updatePartner}
                      >
                        {({
                          handleSubmit,
                          handleChange,
                          values
                        }) => {
                          return (
                            <Form onSubmit={handleSubmit}>
                              <Row>
                                <Col md={12} lg={4}>
                                  <Form.Group>
                                    <Form.Label>{t('REPLAYER_TV_KEEP_VIDEOS')}</Form.Label>
                                    <Form.Control name="rtvKeepVideos" placeholder={t('REPLAYER_TV_KEEP_VIDEOS_DESC')} type="number" min={1} max={100} step={1} value={values.rtvKeepVideos || ''} onChange={handleChange} />
                                  </Form.Group>
                                </Col>
                              </Row>
                              <Button type="submit">{t('SAVE')}</Button>
                            </Form>
                          );
                        }}
                      </Formik>
                    </div>
                    <AdminPartnerRtvChannels />
                  </Tab>
                  <Tab eventKey="video_partner" title={t('PARTNER_VIDEOS')} tabClassName="admin-show-partner-tab">
                    <div className="detail_head_rp rounded">
                      <Formik
                        initialValues={
                          {
                            uid: partner.uid,
                            videoPartnerCost: partner.videoPartnerCost || 0
                          }
                        }
                        onSubmit={updatePartnerVideoCost}
                      >
                        {({
                          handleSubmit,
                          handleChange,
                          values
                        }) => {
                          return (
                            <Form onSubmit={handleSubmit}>
                              <Row>
                                <Col md={12} lg={4}>
                                  <Form.Group>
                                    <Form.Label>{t('PARTNER_VIDEO_COST')}</Form.Label>
                                    <Form.Control name="videoPartnerCost" placeholder={t('PARTNER_VIDEO_COST')} type="number" min={0} step={0.01} value={values.videoPartnerCost} onChange={handleChange} required />
                                  </Form.Group>
                                </Col>
                              </Row>
                              <Button type="submit">{t('SAVE')}</Button>
                            </Form>
                          );
                        }}
                      </Formik>
                    </div>
                    <Form.Group style={{ marginTop: 20 }}>
                      <Button variant="secondary" onClick={() => newXmlPartnerVideoModal(partner.uid)}>{t('XML_UPLOAD')}</Button>
                    </Form.Group>
                    <br /><br /><br /><br /><br />
                  </Tab>
                  <Tab eventKey="shop" title="Shop" tabClassName="admin-show-partner-tab">
                    <AdminShop
                      partnerId={partner.uid}
                      title={`Shop ${partner.businessName}`}
                      ordersTitle={`Ordini Shop ${partner.businessName}`}
                    />
                  </Tab>
                </Tabs>
              </div>
            </div>
          </div>
        </Container>
      </Fade>
      {
        isXmlModalVisible ?
          <Modal show={isXmlModalVisible} onHide={hideXmlModal}>
            <Modal.Header closeButton>
              <Modal.Title>{t('XML')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Formik
                initialValues={{...selectedXml, ...(xmlCopy ? {xmlType: xmlType.advertising} : {})}}
                onSubmit={(values) => {
                  values.selectedFile = selectedFile;
                  createXml({...values, ...(xmlCopy ? {xmlType: xmlType.advertising} : {})});
                }}
              >
                {({
                  handleSubmit,
                  handleChange,
                  setFieldValue,
                  values
                }) => {
                  return (
                    <Form onSubmit={handleSubmit}>
                      <Form.Group>
                        <Form.Label>{t('XML_TYPE')}*</Form.Label>
                        {!xmlCopy && <Form.Check id="field-xml-geometry" required name="xmlType" type="radio" label={t('XML_GEOMETRY')} checked={values.xmlType === xmlType.geometry} onChange={() => setFieldValue('xmlType', xmlType.geometry)} />}
                        {!xmlCopy && <Form.Check id="field-xml-hotspot" required name="xmlType" type="radio" label={t('XML_HOTSPOT')} checked={values.xmlType === xmlType.hotspot} onChange={() => setFieldValue('xmlType', xmlType.hotspot)} />}
                        {xmlCopy && <Form.Text>Geometria e hotspot sono gestiti sul campo originale. Qui puoi caricare le pubblicità di questo partner.</Form.Text>}
                        <Form.Check id="field-xml-advertising" required name="xmlType" type="radio" label={t('XML_ADVERTISING')} checked={values.xmlType === xmlType.advertising} onChange={() => setFieldValue('xmlType', xmlType.advertising)} />
                      </Form.Group>
                      <Form.Group>
                        <Form.Label>{t('SELECT_FILE')}*</Form.Label>
                        <FormFileInput required id="xml" name="xml" type="file" class="form-control-file" onChange={fileChangeHandler} />
                      </Form.Group>
                      <Button variant="secondary" type="submit">{t('SAVE')}</Button>
                    </Form>
                  );
                }}
              </Formik>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="primary" onClick={hideXmlModal}>
                {t('CLOSE_BUTTON')}
              </Button>
            </Modal.Footer>
          </Modal> :
          null
      }
      {
        isXmlPartnerVideoModalVisible ?
          <Modal show={isXmlPartnerVideoModalVisible} onHide={hideXmlPartnerVideoModal}>
            <Modal.Header closeButton>
              <Modal.Title>{t('XML')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Formik
                initialValues={selectedXml}
                onSubmit={(values) => {
                  values.selectedFile = selectedFile;
                  createPartnerVideoXml(values);
                }}
              >
                {({
                  handleSubmit,
                  handleChange,
                  setFieldValue,
                  values
                }) => {
                  return (
                    <Form onSubmit={handleSubmit}>
                      <Form.Group>
                        <Form.Label>{t('XML_TYPE')}*</Form.Label>
                        <Form.Check required name="xmlType" type="radio" label={t('XML_GEOMETRY')} checked={values.xmlType === xmlType.geometry} onChange={() => setFieldValue('xmlType', xmlType.geometry)} />
                        <Form.Check required name="xmlType" type="radio" label={t('XML_HOTSPOT')} checked={values.xmlType === xmlType.hotspot} onChange={() => setFieldValue('xmlType', xmlType.hotspot)} />
                        <Form.Check required name="xmlType" type="radio" label={t('XML_ADVERTISING')} checked={values.xmlType === xmlType.advertising} onChange={() => setFieldValue('xmlType', xmlType.advertising)} />
                      </Form.Group>
                      <Form.Group>
                        <Form.Label>{t('SELECT_FILE')}*</Form.Label>
                        <FormFileInput required id="xml" name="xml" type="file" class="form-control-file" onChange={fileChangeHandler} />
                      </Form.Group>
                      <Button variant="secondary" type="submit">{t('SAVE')}</Button>
                    </Form>
                  );
                }}
              </Formik>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="primary" onClick={hideXmlPartnerVideoModal}>
                {t('CLOSE_BUTTON')}
              </Button>
            </Modal.Footer>
          </Modal> :
          null
      }
      <Modal show={isCameraModalVisible} onHide={hideCameraModal}>
        <Modal.Header closeButton>
          <Modal.Title>{selectedCamera && selectedCamera.name ? selectedCamera.name : t('NEW_CAMERA')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Formik
            initialValues={selectedCamera}
            onSubmit={values => createOrEditCamera(values, partner.uid)}
          >
            {({
              handleSubmit,
              handleChange,
              setFieldValue,
              values
            }) => {
              return (
                <Form onSubmit={handleSubmit}>
                  {values.id ? <p style={{ textAlign: 'right', marginRight: 5 }}>id: {values.id}</p> : null}
                  <Form.Group style={{ marginTop: values.id ? -38 : 0 }}>
                    <Form.Label>{t('CAMERA_NAME')}</Form.Label>
                    <Form.Control required name="name" placeholder={t('CAMERA_NAME')} type="text" value={values.name || ''} onChange={handleChange} />
                  </Form.Group>
                  <Form.Group>
                    <Form.Label>{t('CAMERA_TYPE')}*</Form.Label>
                    <Form.Control required as="select" name="format" value={String(values.format) || ''} onChange={handleChange}>
                      <option value="">{t('GIVE_TYPE')}</option>
                      <option value={1}>{t('PANORAMIC')}</option>
                      <option value={0}>{t('FLAT')}</option>
                      <option value={2}>{t('YOUTUBE')}</option>
                    </Form.Control>
                  </Form.Group>
                  <Form.Group>
                    <Form.Label>{t('CHOOSE_POSITION')}</Form.Label>
                    {
                      fields.find(f => f.id === values.fieldId).cameras.map((element, index) => {
                        return <Form.Check key={index} required name="position" type="radio" label={index + 1} checked={values.position === index + 1} onChange={() => setFieldValue('position', index + 1)} />
                      })
                    }
                    {
                      !values.id ?
                        <Form.Check required name="position" type="radio" label={fields.find(f => f.id === values.fieldId).cameras.length + 1} checked={values.position === fields.find(f => f.id === values.fieldId).cameras.length + 1} onChange={() => setFieldValue('position', fields.find(f => f.id === values.fieldId).cameras.length + 1)} />
                        : null
                    }
                  </Form.Group>
                  <div>
                    <Button variant="secondary" type="submit">{t('SAVE')}</Button>
                    {values.id ?
                      <Button className="btn_black_rp" onClick={() => deleteCameraDialog(values.id, partner.uid)} style={{ marginLeft: 10 }}>{t('DELETE')}</Button> : null}
                  </div>
                </Form>
              );
            }}
          </Formik>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={hideCameraModal}>{t('CANCEL')}</Button>
        </Modal.Footer>
      </Modal>
      <Dialog
        ref={el => {
          dialog = el;
        }} />
    </Fragment>
  );
};

AdminShowPartner.propTypes = {
  partner: PropTypes.object,
  token: PropTypes.string,
  fields: PropTypes.array,
  services: PropTypes.array,
  rtvChannels: PropTypes.array,
  updatePartner: PropTypes.func.isRequired,
  updatePartnerDedicatedPage: PropTypes.func.isRequired,
  updatePartnerField: PropTypes.func.isRequired,
  updatePartnerService: PropTypes.func.isRequired,
  selectedXml: PropTypes.object,
  newXmlModal: PropTypes.func.isRequired,
  isXmlModalVisible: PropTypes.bool.isRequired,
  createXml: PropTypes.func.isRequired,
  hideXmlModal: PropTypes.func.isRequired,
};

AdminShowPartner.defaultProps = {
  partner: null,
  token: null,
  fields: [],
  services: [],
};

const mapStateToProps = ({ login: { token }, admin: { selectedPartner, selectedPartnerFields, selectedPartnerServices, isXmlModalVisible, isXmlPartnerVideoModalVisible, selectedXml, isCameraModalVisible, selectedCamera, adminShowPartnerTab } }) => ({
  token,
  partner: selectedPartner,
  fields: selectedPartnerFields,
  services: selectedPartnerServices,
  isXmlModalVisible,
  isXmlPartnerVideoModalVisible,
  isCameraModalVisible,
  selectedXml,
  selectedCamera,
  adminShowPartnerTab
});

const mapDispatchToProps = dispatch => ({
  refreshFields: partnerId => dispatch(getPartnerFields(partnerId)),
  updatePartner: partner => {
    dispatch(updatePartnerByAdmin(partner));
  },
  updatePartnerDedicatedPage: (partnerId, values) => {
    dispatch(updatePartnerDedicatedPageByAdmin(partnerId, values));
  },

  updatePartnerVideoCost: partner => {
    dispatch(updatePartnerVideoCostByAdmin(partner));
  },

  updatePartnerField: field => {
    dispatch(updatePartnerFieldByAdmin(field));
  },

  updatePartnerService: service => {
    dispatch(updatePartnerServiceByAdmin(service));
  },

  newXmlModal: fieldId => {
    dispatch(newXml(fieldId));
    dispatch(showXmlModal());
  },

  newXmlPartnerVideoModal: partnerId => {
    dispatch(newXmlPartnerVideo(partnerId));
    dispatch(showXmlPartnerVideoModal());
  },

  cameraModal: (camera, fieldId) => {
    if (camera === null) {
      dispatch(newCamera(fieldId));
    }
    else {
      dispatch(editCamera(camera));
    }
    dispatch(showCameraModal());
  },

  createXml: values => {
    dispatch(saveXml(values));
  },

  createPartnerVideoXml: values => {
    dispatch(savePartnerVideoXml(values));
  },

  hideXmlModal: () => {
    dispatch(hideXmlModal());
  },

  hideXmlPartnerVideoModal: () => {
    dispatch(hideXmlPartnerVideoModal());
  },

  hideCameraModal: () => {
    dispatch(hideCameraModal());
  },

  showCameraModal: () => {
    dispatch(hideCameraModal());
  },

  createOrEditCamera: (values, partnerId) => {
    values.format = parseInt(values.format);
    if (!values.id) {
      dispatch(createCamera(values, partnerId));
    }
    else {
      dispatch(modifyCamera(values, partnerId));
    }
  },
  deleteCamera: (cameraId, partnerId) => {
    dispatch(deleteCamera(cameraId, partnerId));
  },
  changePartnerPermissions: (values, partnerId) => {
    dispatch(changePartnerPermissions(values, partnerId));
  },
  setAdminShowPartnerTab: (tabKey) => {
    dispatch(setAdminShowPartnerTab(tabKey))
  },

});

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(AdminShowPartner));
